import type { IConfig } from "App/Modules/Utils";

// Not available anymore
// import {} from "angular-co";

import "angular-translate";
import "angular-translate-handler-log";
import "angular-translate-loader-url";
import "angular-translate-storage-cookie";
import "angular-translate-storage-local";
import momentDurationFormatSetup from "moment-duration-format";
import moment from "moment-timezone";
// import "angular-translate-interpolation-messageformat";

declare function require(path: string): { [key: string]: angular.translate.ITranslationTable };

export default [
    "$translateProvider",
    "irConfig",
    ($translateProvider: angular.translate.ITranslateProvider, config: IConfig) => {
        const langs = require("../Translations/beforeLogin.lang"); // eslint-disable-line

        // eslint-disable-next-line no-restricted-syntax
        for (const lang in langs) {
            if (langs.hasOwnProperty(lang)) {
                $translateProvider.translations(lang, langs[lang]);
            }
        }

        // Comment 2017: Replace with "escape" "sanitize" when double encoding issues are fixed
        $translateProvider.useSanitizeValueStrategy("escape");
        $translateProvider.useLocalStorage(); // Store chosen language
        $translateProvider.addInterpolation("$irTranslateMessageFormatInterpolation");
        // $translateProvider.useMissingTranslationHandlerLog();
        $translateProvider.uniformLanguageTag("bcp47");

        /* eslint-disable @typescript-eslint/naming-convention */
        $translateProvider.registerAvailableLanguageKeys(["en", "sv"], {
            "en_*": "en",
            "sv_*": "sv",
            "*": "en",
        });
        /* eslint-enable */

        $translateProvider.determinePreferredLanguage();
        $translateProvider.useLoader("i18nLanguageCacheLoader", { url: `${config.apiUrl}translations` });

        $translateProvider.forceAsyncReload(true);

        momentDurationFormatSetup(moment as any); // Adds format() to the Duration type
    },
];
